import * as types from '../actionsTypes/corso_corsiActionsType'

import {
    giustificativiActions,
    individuoActions,
    loadingOverlayActions,
    notifsActions,
    tipiAttivitaActions
} from '../index';
import {pianificazioniActions} from "../../slices/pianificazioniSlice";
import new_axios_instance from '../../axios_instance';
import {
    convertBase64ToBlob,
    createMessageRequestException,
    encodeUnicode,
    printOnlyInDevelopment
} from "../../fanctionUtility";
import {corsoCorsiActions} from "../../slices/corso_corsiSlice";
import {dayJS} from "../../applicationConf";
import {loadStorage} from '../../sessionStorage';
import axios from 'axios';


//Ricerca Corsi
export const getCorsiSearch = (paramRicerca) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());

    await new_axios_instance.post('/v1/corso/ricerca', paramRicerca)
        .then(response => {
            dispatch(corsoCorsiActions.getCorsiSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        }).catch(error => {
            const message = createMessageRequestException(error);

            dispatch(corsoCorsiActions.getCorsiFail(message));
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        });
};


export const getLoadDataOfCourse = () => ({
    type: types.GET_LOAD_DATA_OF_COURSE
});


//Corso Singolo
export const getCorsoStart = (id) => async dispatch => {

    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(individuoActions.initIndividui());
    dispatch(pianificazioniActions.pianificazioniInit());
    dispatch(individuoActions.initDocenti());
    dispatch(tipiAttivitaActions.initAttivitaByTipoCorso());
    dispatch(giustificativiActions.initTipiGiustificativi());
    dispatch(corsoCorsiActions.initCorso());

    await new_axios_instance.get(`/v1/corso/ricerca/${id}`)
        .then(response => {
            dispatch(corsoCorsiActions.getCorsoSuccess(response.data));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        }).catch(error => {
            const message = createMessageRequestException(error);

            dispatch(corsoCorsiActions.getCorsoFail(true));
            dispatch(notifsActions.notifError(message));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
            window.scrollTo({top: 0, behavior: "smooth"})
        })
};

export const getAllTipiCorsoStart = () => async dispatch => {
    await new_axios_instance.get('/v1/corso/ricercaTipoCorso')
        .then(response => {
            printOnlyInDevelopment('Recupero di tutti i tipiCorso :: ', response.data);
            dispatch(corsoCorsiActions.getAllTipiCorsoSuccess(response.data));
        }).catch(error => {
            const message = createMessageRequestException(error);
            dispatch(notifsActions.notifError(message));
            dispatch(corsoCorsiActions.getAllTipiCorsoError(true));
        })
};

export const modificaAllievoCorso = (obj) => async dispatch => {

    dispatch(loadingOverlayActions.showLoadingOverlay());

    await new_axios_instance.post(`/v1/corso/modifica/allievo`, obj)
        .then(response => {
            dispatch(notifsActions.notifSuccess('Operazione avvenuta con successo'));
            dispatch(corsoCorsiActions.updateAllieviCorso(response.data))
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
        .catch(error => {
            dispatch(notifsActions.notifError(createMessageRequestException(error)));
            dispatch(loadingOverlayActions.hideLoadingOverlay());
        })
}

export const getParticipantsToTheDateStart = (idCorso, data = dayJS().format('YYYY-MM-DD')) => async dispatch => {
    await new_axios_instance.get(`/v1/corso/ricerca/allievi/${idCorso}/data/${data}`)
        .then((response) => {
            dispatch(corsoCorsiActions.getParticipantsToTheDateSuccess(response.data))
        })
        .catch(error => dispatch(notifsActions.notifError(createMessageRequestException(error))))
}

export const getPDFSchedaCorso = (json) => async dispatch => {
    const conf = loadStorage().configurationFile.fileConf;

    const headers = {
        ...new_axios_instance.defaults.headers
    };

    headers['Accept'] = '*/*';

    dispatch(loadingOverlayActions.showLoadingOverlay());

    await axios.post(`${conf.baseUrlPDFService}/${conf.contextPDFService}/v1/pdf/create`,
        {
            codeTemplate: "scheda_corso",
            json: encodeUnicode(JSON.stringify(json))
        },
        {headers}
    ).then(response => {
        convertBase64ToBlob(response.data, 'scheda_corso.pdf');
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    }).catch(error => {
        const message = createMessageRequestException(error);
        dispatch(notifsActions.notifError(message));
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    })

}


